


import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, ViewChild, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { DynamicFormsV2Component } from '../../shared/dynamic-forms-v2/dynamic-forms-v2.component';
import { CodeableConceptField, CodeField, GroupField, IndividualField, IndividualReferenceField, ReferenceFieldArray, formMetaData, codeableConceptDataType, ReferenceDataType, codingDataType, SingleCodeField } from '../../shared/dynamic-forms.interface2';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { ErrorService } from '../../shared/error.service';
import { firstValueFrom, forkJoin, map, of } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ResourceDataReviewComponent } from '../../shared/resource-data-review/resource-data-review.component'; // added
import { backendEndPointToken } from '../../app.config';
import { LoaderComponent } from '../../loader/loader.component';
import { UtilityService } from '../../shared/utility.service';
type FormFields = IndividualField | ReferenceFieldArray | CodeableConceptField | CodeField | IndividualReferenceField | GroupField;


@Component({
  selector: 'app-add-lab-requests',
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, DynamicFormsV2Component, ReactiveFormsModule, MatIconModule,
    MatButtonModule, ResourceDataReviewComponent /* added */
  ],
  templateUrl: './add-specimen.component.html',
  styleUrls: ['../../lab-requests/add-lab-requests/add-lab-requests.component.scss']
})
export class AddSpecimenComponent {
  //constructor with optional mat dialog
  http = inject(HttpClient);
  private fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialogRef = inject(MatDialogRef<AddSpecimenComponent>, { optional: true }) as MatDialogRef<AddSpecimenComponent> | null;
  private readonly data = inject(MAT_DIALOG_DATA, { optional: true }) as any;
  backendEndPoint = inject(backendEndPointToken);
  public _patientId?: string;
  public _serviceRequestId?: string;
  @Input() set patientId(value: string | undefined) {
    this._patientId = value;
  }
  @Input() set serviceRequestId(value: string | undefined) {
    this._serviceRequestId = value;
  }

  // Root form with a form array that mirrors fields in this.formFields
  requestForm: FormGroup = this.fb.group({
    items: this.fb.array([])
  });

  get items(): FormArray {
    return this.requestForm.get('items') as FormArray;
  }

  // Builds one form group whose controls match this.formFields by fieldApiName
  private buildItemGroup(overrideValues?: Record<string, any>): FormGroup {
    const controls: Record<string, FormControl> = {};
    (this.formFields || []).forEach(f => {
      const apiName = f.generalProperties.fieldApiName;
      let initial: any;
      if (overrideValues && Object.prototype.hasOwnProperty.call(overrideValues, apiName)) {
        initial = overrideValues[apiName]; // highest precedence
      } else if ('value' in f.generalProperties) {
        initial = (f as any).generalProperties.value;
      } else {
        initial = null;
      }
      controls[apiName] = new FormControl(initial);
    });
    return this.fb.group(controls);
  }

  // Sync single field edits from ResourceDataReviewComponent
  async onFieldEdited(index: number, evt: { fieldApiName: string; newValue: any; isArray?: boolean; arrayIndex?: number }) {
    const group = this.items.at(index) as FormGroup;
    if (!group) return;
    if (await this.processValues({ ...this.items.at(index).value, [evt.fieldApiName]: evt.newValue },
      true) as boolean) {

      group.patchValue({ [evt.fieldApiName]: evt.newValue });
    }
  }

  // Sync full resource object updates
  async onResourceUpdated(index: number, updated: any) {
    const group = this.items.at(index) as FormGroup;
    if (!group) return;
    if (await this.processValues(updated, true) as boolean) {
      group.patchValue(updated);
    }
  }

  dialog = inject(MatDialog)

  constructor() {
    if (this.data?.patientId) {
      this.patientId = this.data.patientId;
    }
    if (this.data?.serviceRequestId) {
      this.serviceRequestId = this.data.serviceRequestId;
    }
  }
  submittedValues: any;


  utilityService = inject(UtilityService);

  isChosenOption = false;
  isMultiple = new FormControl(null);
  formMetaData?: formMetaData;
  formFields?: FormFields[];
  formFieldsDataService = inject(FormFieldsSelectDataService);
  errorService = inject(ErrorService);
  medicineForms: { formFields: FormFields[], formMetaData: formMetaData }[] = [

  ]

  ngOnInit() {
    this.formMetaData = <formMetaData>{
      // formName: 'Service Request (Lab Tests, e.t.c.)',
      // formDescription: "Use this form to order a lab test or any other medical services from your or other department",
      // submitText: 'Submit Request',

      formName: "Use this form to enter a specimen record",
      formDescription: "Use this form to record a specimen for a specific lab test",
      submitText: ` ${this.isMultiple.value && this.isMultiple.value == 'Multiple'
        ? 'Add' : 'Submit'} Specimen Record`,

    };
    this.isMultiple.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e: boolean | null) => {
      if (e !== null) {
        this.isChosenOption = true;
      }
      this.formMetaData = <formMetaData>{
        // formName: 'Service Request (Lab Tests, e.t.c.)',
        // formDescription: "Use this form to order a lab test or any other medical services from your or other department",
        // submitText: 'Submit Request',


        formName: "Use this form to enter a specimen record",
        formDescription: "Use this form to record a specimen for a specific lab test",
        submitText: ` ${this.isMultiple.value && this.isMultiple.value == 'Multiple'
          ? 'Add' : 'Submit'} Specimen Record`,
      }
    })


    console.log(`${this.backendEndPoint}/ServiceRequest`)


    forkJoin({
      status: this.formFieldsDataService.getFormFieldSelectData('specimen', 'status'),
      type: this.formFieldsDataService.getFormFieldSelectData('specimen', 'type'),
      condition: this.formFieldsDataService.getFormFieldSelectData('specimen', 'condition'),
      bodySite: this.formFieldsDataService.getFormFieldSelectData('specimen', 'bodySite'),
      subject: this.formFieldsDataService.getFormFieldSelectData('specimen', 'subject'),
      request: this.formFieldsDataService.getFormFieldSelectData('specimen', 'request'),
      // patientSpecificRequest: this._patientId ? this.http.get(`${this.backendEndPoint}/ServiceRequest`).pipe(
      //   // Filter to only those for the specific patient
      //   map((srBundle: any) => {
      //     srBundle.entry = srBundle.entry.filter((entry: any) => {
      //       const sr: any = entry.resource;
      //       return sr.subject && sr.subject.reference.includes(`Patient/${this._patientId}`);
      //     });
      //     return srBundle;
      //     console.log(srBundle);
      //     const toReturn = this.formFieldsDataService.serviceRequestBundleToReferenceData(srBundle)
      //     console.log(toReturn);
      //     return toReturn;
      //   }),

      // ) : (of([])),
      PatientSpecificRequest: this._patientId ? this.utilityService.threeTierQueryAndSyncToStateOnce$({
        resourceType: 'ServiceRequest',
        tier1FollowNextLinks: true,

        tier3FollowNextLinks: true,
        tier1MaxPages: 10,
        tier3MaxPages: 10,
        urlSearchObject: {
          status: 'active'
        },
        scope: 'orgWide',
        querySearchObject: [
          {
            key: 'subject.reference',
            value: this.backendEndPoint + `/Patient/${this._patientId}`
          },
          {
            key: 'subject.reference',
            value: `Patient/${this._patientId}`
          },
          {
            key: 'status',
            value: 'active'
          }
        ]
      }) : of([])
      // code: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'code'),
      // performerType: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'performerType'),
      // priority: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'priority'),
    }).subscribe({
      next: (g: any) => {
        console.log(g.PatientSpecificRequest)
// $#$        //  /* alert(this._patientId); */ /* alert(this._serviceRequestId) */

        //  const dRef = this.dialog.open(DynamicFormsV2Component, {
        //  maxHeight: '90vh',
        //  maxWidth: '650px',
        //  autoFocus: false,
        //  data: {
        this.formMetaData = {
          formName: 'Specimen Record ',
          formDescription: "Use this form to record specimens for a specific lab test",
          submitText: 'Submit Request',
        },
          this.formFields = [
            {
              generalProperties: {

                fieldApiName: 'status',
                fieldName: 'Status of Specimen',
                fieldLabel: 'Status of Specimen',
                value: 'Available',
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },

                fieldType: 'SingleCodeField',
                isArray: false,
                isGroup: false
              },
              data: "available | unavailable | unsatisfactory | entered-in-error".split('|').map((e: string) => e.trim().slice(0, 1).toUpperCase() + e.trim().slice(1))

            }, {
              generalProperties: {

                fieldApiName: 'type',
                fieldName: 'Specimen Type',
                fieldLabel: 'Specimen Type',

                fieldPlaceholder: "BLOOD, URINE, TISSUE etc",
                moreHint: "The kind of specimen collected",

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },

                fieldType: 'CodeableConceptField',
                isArray: false,
                isGroup: false
              },
              data: g.type

            },
            //subject
            {
              generalProperties: {
                fieldApiName: 'subject',
                fieldName: 'Who Specimen is from',
                fieldLabel: 'Who Specimen is from',
                value: this._patientId ? "Patient/" + this._patientId : "",
                isHidden: this._patientId ? true : false,
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldType: 'IndividualReferenceField',
                isArray: false,
                isGroup: false
              },
              data: g.subject
            },
            {
              generalProperties: {
                fieldApiName: 'request',
                fieldName: 'Referenced Lab Test Request ',
                fieldLabel: 'Referenced Lab Test Request ',
                moreHint: "Lab request for which this specimen is intended",
                value: this._serviceRequestId ? "ServiceRequest/" + this._serviceRequestId : "",
                isHidden: this._serviceRequestId ? true : false,

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldType: 'IndividualReferenceField',
                isArray: false,
                isGroup: false
              },
              data: this.patientId ? g.patientSpecificRequest : g.request
            },
            <IndividualField>{
              generalProperties: {

                fieldApiName: 'receivedTime',
                fieldName: 'Received Date',
                fieldLabel: 'Received Date',
                fieldType: 'IndividualField',

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                validations: [
                  {
                    type: 'default',
                    name: 'required',


                  }
                ],

                inputType: 'datetime-local',
                isArray: false,
                isGroup: false
              },


            },

            <IndividualField>{
              //receivedTime
              generalProperties: {
                fieldApiName: 'receivedTimeTime',
                fieldName: 'Received Time',
                fieldLabel: 'Received Time',
                fieldType: 'IndividualField',
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                validations: [
                  {
                    type: 'default',
                    name: 'required',


                  }
                ],
                inputType: 'time',
                isArray: false,
                isGroup: false,
                // dependence_id: 'receivedTime'
              },


            },
            //collection.collectedDateTime

            //collection.collector

            {
              generalProperties: {

                fieldApiName: 'condition',
                fieldName: 'Specimen Condition',
                fieldLabel: 'Specimen Condition',


                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },


                fieldType: 'CodeableConceptField',
                isArray: true,
                isGroup: false
              },
              data: g.condition


            },
            //collectedTime
            <GroupField>{
              generalProperties: {
                fieldApiName: 'collectedTime',
                fieldName: 'Collection Time',
                fieldLabel: 'Collection Time',
                fieldType: 'IndividualField',
                groupFieldsHint: "If specimen was collected over a period of time, select 'Yes' and provide start and end times. If collected at a single time, select 'No' and provide the collection date and time.",
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                inputType: 'datetime-local',
                isArray: false,
                isGroup: true,
              },

              keys: ['isCollectedOverPeriod', 'collectionStart', 'collectionEnd', 'collectionDateTime'],
              groupFields: {
                'isCollectedOverPeriod': <SingleCodeField>{
                  //is collected over a period or single time option
                  generalProperties: {
                    fieldApiName: 'isCollectedOverPeriod',
                    fieldName: 'Is collection over a period of time?',
                    fieldLabel: 'Is collection over a period of time?',
                    fieldType: 'SingleCodeField',
                    controllingField: [
                      {
                        controlledFieldDependencyId: 'collectedTime',
                        dependentFieldVisibilityTriggerValue: 'No',
                        isAControlField: true
                      },
                      {
                        controlledFieldDependencyId: 'collectionStart',
                        dependentFieldVisibilityTriggerValue: 'Yes',
                        isAControlField: true
                      },
                      {
                        controlledFieldDependencyId: 'collectionEnd',
                        dependentFieldVisibilityTriggerValue: 'Yes',
                        isAControlField: true
                      }

                    ],
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },

                    isArray: false,
                    isGroup: false,

                  },
                  data: ['Yes', 'No']

                },
                'collectionStart': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionStart',
                    fieldName: 'Collection Start Date',
                    fieldLabel: 'Collection Start Date',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'datetime-local',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectionStart',

                  },
                },
                'collectionStartTime': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionStartTime',
                    fieldName: 'Collection Start Time',
                    fieldLabel: 'Collection Start Time',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'time',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectionStart',
                  },
                },
                'collectionEnd': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionEnd',
                    fieldName: 'Collection End Date',
                    fieldLabel: 'Collection End Date',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'datetime-local',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectionEnd',
                  },

                },
                'collectionEndTime': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionEndTime',
                    fieldName: 'Collection End Time',
                    fieldLabel: 'Collection End Time',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'time',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectionEnd',
                  },
                },
                'collectionDateTime': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionDateTime',
                    fieldName: 'Collection Date Time',
                    fieldLabel: 'Collection Date Time',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'datetime-local',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectedTime',
                  },
                },
                'collectionTime': <IndividualField>{
                  generalProperties: {
                    fieldApiName: 'collectionTime',
                    fieldName: 'Collection Time',
                    fieldLabel: 'Collection Time',
                    fieldType: 'IndividualField',
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                    inputType: 'time',
                    isArray: false,
                    isGroup: false,
                    dependence_id: 'collectedTime',
                  },
                },
              }
            },

            {
              generalProperties: {

                fieldApiName: 'bodySite',
                fieldName: 'Body Collection Site',
                fieldLabel: 'Body Collection Site',

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },


                fieldType: 'CodeableConceptFieldFromBackEnd',
                isArray: false,
                isGroup: false
              },
              data: g.bodySite


            },
            <IndividualField>{
              generalProperties: {

                fieldApiName: 'note',
                fieldName: 'Additional Notes',
                fieldLabel: 'Additional Notes',
                fieldType: 'IndividualField',
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                inputType: 'textarea',
                isArray: false,
                isGroup: false
              },

            }
          ]


      },
      error: (err: any) => {
        console.log(err);
        this.errorService.openandCloseError("An error ocurred while fetching specimen data");
      }
    });



  }
  loader = false;
  addMoreMedicineRequest() {

    if (this.formMetaData && this.formFields) {
      // this.medicineForms = [...this.medicineForms, { formMetaData: this.formMetaData, formFields: [...this.formFields] }];
      // Add another group mirroring current formFields
      this.items.push(this.buildItemGroup());
    }
  }

  @ViewChild('cref') dynamicFormComponent!: DynamicFormsV2Component;
  // stringifiedService = inject()
  private normalizeReferenceValue(raw: any): string {
    if (raw === null || raw === undefined) return '';
    if (typeof raw === 'object') {
      const ref = (raw as any)?.reference;
      return ref ? String(ref).trim() : '';
    }

    const str = String(raw).trim();
    if (!str) return '';

    // Many of our dynamic-forms reference fields encode multiple pieces with $#$.
    // Pick the segment that looks like a FHIR reference (e.g., Patient/123, ServiceRequest/abc).
    if (str.includes('$#$')) {
      const parts = str.split('$#$').map((p) => p.trim()).filter(Boolean);
      const refLike = parts.find((p) => /\w+\/[A-Za-z0-9\-\.]{1,}/.test(p));
      return (refLike ?? parts[parts.length - 1] ?? str).trim();
    }
    return str;
  }

  private extractIdFromReference(ref: string): string {
    const r = (ref ?? '').toString().trim();
    if (!r) return '';
    const parts = r.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  async processValues(values: any, returnBooleanValue: boolean = false): Promise<boolean | void> {

    if (!values) {
      if (!returnBooleanValue) {
        return;
      } else {
        return false;
      }


    }

    // Validate that chosen ServiceRequest belongs to chosen subject/patient.
    let loaderRef: any | null = null;
    try {
      const requestRef = this.normalizeReferenceValue(values.request);
      const subjectRef = this.normalizeReferenceValue(values.subject);

      // If required references aren't present yet:
      // - for inline edits (boolean path), treat as "not valid"
      // - for submit path, fall back to normal required-field validation
      if (!requestRef || !subjectRef) {
        if (returnBooleanValue) return false;
        this.continueProcess(values);
        return;
      }

      // Avoid spamming modal loaders during inline edits.
      if (!returnBooleanValue) {
        loaderRef = this.dialog.open(LoaderComponent, {
          width: '250px',
          disableClose: true,
          data: { message: 'Validating Service Request...' }
        });
      }

      const sr: any = await firstValueFrom(this.http.get(`${this.backendEndPoint}/${requestRef}`));
      const srSubjectRef = this.normalizeReferenceValue(sr?.subject);

      const srPatientId = this.extractIdFromReference(srSubjectRef);
      const chosenPatientId = this.extractIdFromReference(subjectRef);

      if (srPatientId && chosenPatientId && srPatientId !== chosenPatientId) {
        this.errorService.openandCloseError(
          'The selected Service Request does not belong to the selected Subject/Patient. You can hover on the info of each service request to see the patient it belongs to.'
        );
        if (returnBooleanValue) return false;
        return;
      }

      if (!returnBooleanValue) {
        this.continueProcess(values);
        return;
      }
      return true;
    } catch (err: any) {
      this.errorService.openandCloseError('An error occurred while validating the Service Request.');
      if (returnBooleanValue) return false;
      return;
    } finally {
      try {
        loaderRef?.close?.();
      } catch {
        // no-op
      }
    }
  }
  continueProcess(values: any) {


    const isEmpty = (v: any) => v === null || v === undefined || String(v).trim() === '';


    //type, status, subject and service requested are required
    if (
      !values.type || !values.status || !values.subject || !values.request
    ) {
      this.errorService.openandCloseError('Type, Status, Subject, and Service Requested fields are required.');

      return;
    }

    // receivedTime and receivedTimeTime are required for label printing + lab workflows
    if (isEmpty(values.receivedTime) || isEmpty(values.receivedTimeTime)) {
      this.errorService.openandCloseError('Received Date and Received Time are required.');
      return;
    }

    if (values.collectedTime && values.isCollectedOverPeriod === 'Yes'
      && (!values.collectedTime?.collectionStart || !values.collectedTime?.collectionEnd)) {
      this.errorService.openandCloseError('Please provide both Collection Start and End times, or select "No" for collection over a period.');
      return;
    }

    if (values.collectedTime && values.isCollectedOverPeriod === 'No' && !values.collectedTime?.collectionDateTime) {
      this.errorService.openandCloseError('Please provide Collection Date Time, or select "Yes" for collection over a period.');
      return;
    }




    if (!this.isMultiple.value || this.isMultiple.value == 'Single') {
      console.log(values);
      this.dialogRef?.close({ values: values });
      return;
    }
    //vallidationbefore `pushing

    this.items.push(this.buildItemGroup(values));
  }

  submitAllRequests() {
    const allValues = this.items.value;
    console.log(JSON.stringify(allValues));
    //validate -> if any of the entries fail validation, show error and do not proceed
    for (const values of allValues) {
      if (!values.type || !values.status || !values.subject || !values.request) {
        this.errorService.openandCloseError('Type, Status, Subject, and Service Requested fields are required for all entries.');
        return;
      }

      const isEmpty = (v: any) => v === null || v === undefined || String(v).trim() === '';
      if (isEmpty(values.receivedTime) || isEmpty(values.receivedTimeTime)) {
        this.errorService.openandCloseError('Received Date and Received Time are required for all entries.');
        return;
      }
    }
    this.dialogRef?.close({ values: allValues });
  }
}
